

export const colors =  {
    primary: 'rgb(255, 255, 255)',
    secondary: 'rgb(31, 39, 50)',
    acent: 'rgb(209, 176, 107)',
    fluid: 'rgba(255, 255, 255, 0.1)',
    lightGray: 'rgb(59, 67, 78)',
    darkGray: 'rgb(22, 29, 39)',
    white_grey: 'rgb(215, 215, 215)',
    secondary_tr: 'rgba(31, 39, 50, 0.85)',
    error: '#DC3545',
    success: '#28A745',
    warning: '#FFC107',
    info: '#17A2B8',
    light: '#E9ECEF',
    dark: '#343A40',
    lighter: '#F8F9FA',
    darker: '#212529',
    lightest: '#F7F'
}
